import EventEmitter from 'events';
import { ZoneSelectList, ZoneRadioButtonList } from './ZoneSelectorControls';

class ZoneSelector extends EventEmitter {
  /**
   * @param {HTMLElement} el
   * @param {number} selectedZoneId
   */
  constructor(el, selectedZoneId = null) {
    super();
    this.bindMethods();

    this.selectedZoneId = null;
    this.el = el;

    const inputs = Array.from(this.el.querySelectorAll('.tn-ticket-selector__input-zone'));

    if (inputs[0].tagName === 'SELECT') {
      this.control = new ZoneSelectList(inputs[0]);
    } else {
      this.control = new ZoneRadioButtonList(inputs);
    }

    this.zoneIds = this.control.collectZoneIds();

    if (this.zoneIds.length === 1) {
      selectedZoneId = this.zoneIds[0];
    }

    this.control.on('change', this.setSelectedZone);

    this.setSelectedZone(selectedZoneId);
  }

  bindMethods() {
    this.setSelectedZone = this.setSelectedZone.bind(this);
  }

  getSelectedZoneId() {
    return this.selectedZoneId;
  }

  setSelectedZone(zoneId) {
    if (zoneId === this.selectedZoneId) {
      return;
    }

    if (zoneId !== null && !this.zoneIds.includes(zoneId)) {
      // console.log(`skipping invalid zoneId: ${zoneId}`);
      return;
    }

    this.selectedZoneId = zoneId;

    this.control.selectZone(this.selectedZoneId);

    this.emit('update', this.selectedZoneId);
  }

  destroy() {
    this.removeAllListeners();
    this.control.destroy();
  }
}

export default ZoneSelector;



// WEBPACK FOOTER //
// ./V7/events/detail/ZoneSelector.js